import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';


function UtilisateurAutocomplete({ onChange, required, variant, size, color, autoFocus, error, helperText }) {

    const [utilisateurs, setUtilisateurs] = useState([]);

    const [selected, setSelected] = React.useState(null);

    const [query, setQuery] = useState('');

    const [results, setResults] = useState([]);

    const [loading, setLoading] = useState(false);

    // Fetch des fournisseurs
    useEffect(() => {
        const fetchData = async () => {

            if (query.length >= 2) {
                let cache = null;
                let len = query.length;
                do {
                    cache = results.find(x => x.key === query.substring(0, len)); // eslint-disable-line no-loop-func
                    len--;
                }
                while (!cache && (len >= 2));

                if (cache) {
                    setUtilisateurs(cache.data);
                }
                else {
                    setLoading(true);

                    axios.get(`api/utilisateurs/suggestion?query=${query}`)
                        .then((response) => {
                            setResults([...results, { key: query, data: response.data }]);
                            setUtilisateurs(response.data);
                        })
                        .catch((error) => {
                            console.log(error);
                        })
                        .then(() => {
                            // always executed
                            setLoading(false);
                        });
                }
            }
        };

        fetchData();
    }, [query]);


    return (
        <>
            <Autocomplete
                options={utilisateurs}
                getOptionLabel={(option) => `${option.codePO} - ${option.nom}`}
                loading={loading}
                value={selected}

                onChange={(event, newValue) => {
                    setSelected(newValue);
                    onChange(newValue.id);
                }}

                onInputChange={(event, newInputValue) => {
                    setQuery(newInputValue);
                }}

                isOptionEqualToValue={(option, value) => {
                    return (option.id === value.id);
                }}

                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Utilisateur"
                        placeholder="Saisir un code PO ou un nom d'utilisateur"
                        required={required}
                        variant={variant}
                        size={size}
                        color={color}
                        fullWidth
                        InputLabelProps={{
                            shrink: true
                        }}
                        autoFocus={autoFocus}
                        error={error}
                        helperText={helperText}
                    />
                )}
            />
        </>
    );
}

UtilisateurAutocomplete.propTypes = {
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    utilisateurId: PropTypes.number,

    variant: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string,
    autoFocus: PropTypes.bool,

    error: PropTypes.bool,
    helperText: PropTypes.string,
};

UtilisateurAutocomplete.defaultProps = {
    required: false,
    utilisateurId: 0,

    variant: "outlined",
    size: "medium",
    color: "primary",
    autoFocus: false,

    error: false,
    helperText: "",
}

export default UtilisateurAutocomplete;